'use es6';

import { debounce } from 'underscore';
import { saveByPath as saveTemplateByPath } from 'DesignData/actions/TemplateBuffers';
import { saveByPath as saveRawAssetByPath } from 'DesignData/actions/RawAssetBuffers';
import { getRawAsset } from 'DesignData/selectors/rawAssetBuffers';
import { DEBOUNCE_DELAY } from 'DesignData/constants/Autosave';
import { TEMPLATE_BUFFER_UPDATE_SOURCE, RAW_ASSET_BUFFER_UPDATE_SOURCE } from 'DesignData/actions/ActionTypes';
const TEMPLATE_AUTOSAVE_ACTIONS = {
  TEMPLATE_BUFFER_UPDATE_SOURCE
};
const RAW_ASSET_AUTOSAVE_ACTIONS = {
  RAW_ASSET_BUFFER_UPDATE_SOURCE
};
const debouncedSaveTemplate = debounce((dispatch, getState, templateId) => {
  dispatch(saveTemplateByPath(templateId));
}, DEBOUNCE_DELAY);
const debouncedSaveRawAsset = debounce((dispatch, getState, rawAssetId) => {
  const rawAsset = getRawAsset(getState(), {
    rawAssetId
  });
  if (!rawAsset) return;
  dispatch(saveRawAssetByPath(rawAssetId));
}, DEBOUNCE_DELAY);
export default (({
  dispatch,
  getState
}) => next => action => {
  const result = next(action);
  const {
    templateId,
    rawAssetId,
    type
  } = result;

  if (templateId && TEMPLATE_AUTOSAVE_ACTIONS[type]) {
    debouncedSaveTemplate(dispatch, getState, templateId);
  }

  if (rawAssetId && RAW_ASSET_AUTOSAVE_ACTIONS[type]) {
    debouncedSaveRawAsset(dispatch, getState, rawAssetId);
  }

  return result;
});